const keysMap = {
  file: 'original',
  croppedFile: 'cropped',
  zoom: 'options.zoom',
  x: 'options.xCoordinate',
  y: 'options.yCoordinate',
  width: 'options.width',
  height: 'options.height',
};

export const createSendHeaderImgData = (data) => {
  const formData = new FormData();
  Object.entries(keysMap).forEach(([key, value]) => {
    formData.append(value, data[key]);
  });

  return formData;
};
